var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownPrice = function SvgArrowDownPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-price_svg__Frame 4576181",
    clipPath: "url(#arrow-down-price_svg__clip0_18479_82976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-down-price_svg__Union",
    d: "M8.38395 15.339C8.18405 15.5789 7.81563 15.5789 7.61573 15.339L0.683251 8.42007C0.411865 8.0944 0.643444 7.59997 1.06736 7.59997H5.1V0.900024C5.1 0.623882 5.32386 0.400024 5.6 0.400024H10.4C10.6761 0.400024 10.9 0.623882 10.9 0.900024V7.59997H14.9323C15.3562 7.59997 15.5878 8.0944 15.3164 8.42007L8.38395 15.339Z",
    fill: "url(#arrow-down-price_svg__paint0_linear_18479_82976)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow-down-price_svg__paint0_linear_18479_82976",
    x1: 8,
    y1: 15.7999,
    x2: 8,
    y2: -1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854301,
    stopColor: "#FFF5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFF5F6",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-down-price_svg__clip0_18479_82976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export default SvgArrowDownPrice;